// Generated by CoffeeScript 2.4.1
(function() {
  var Functions, Promise, Weaver, _;

  Promise = require('bluebird');

  Weaver = require('./Weaver');

  _ = require('lodash');

  Functions = class Functions {
    static batchRemove(nodes, writes = [], unrecoverable = false) {
      var j, len, node;
      for (j = 0, len = nodes.length; j < len; j++) {
        node = nodes[j];
        writes.push({
          cascade: true,
          action: unrecoverable ? 'remove-node-unrecoverable' : 'remove-node',
          id: node.id(),
          graph: node.getGraph(),
          removeId: Weaver.Node.generateId(),
          removeGraph: node.getGraph()
        });
      }
      return writes;
    }

    static popWrites(holder, writes = []) {
      var cleanWrite, j, len, ref, write;
      ref = holder._pendingWrites;
      for (j = 0, len = ref.length; j < len; j++) {
        write = ref[j];
        cleanWrite = _.omit(write, "__pendingOpNode");
        writes.push(cleanWrite);
      }
      holder._pendingWrites = [];
      return writes;
    }

    static collectWrites(holder, writes = []) {
      var j, len, ref, write;
      ref = holder._collectPendingWrites();
      for (j = 0, len = ref.length; j < len; j++) {
        write = ref[j];
        writes.push(_.omit(write, "__pendingOpNode"));
      }
      return writes;
    }

    static executeWrites(writes, clean = true, params) {
      var cm, i;
      if (clean) {
        // remove links to nodes
        writes = (function() {
          var j, len, results;
          results = [];
          for (j = 0, len = writes.length; j < len; j++) {
            i = writes[j];
            results.push(_.omit(i, "__pendingOpNode"));
          }
          return results;
        })();
      }
      cm = Weaver.getCoreManager();
      return cm.enqueue(() => {
        return cm.executeOperations(writes, params);
      });
    }

    static batchChangeAttributeKey(nodes, oldKey, newKey, writes = []) {
      var j, len, node;
      for (j = 0, len = nodes.length; j < len; j++) {
        node = nodes[j];
        writes.push({
          action: 'change-attribute-key',
          id: node.id(),
          attributeKey: oldKey,
          newAttributeKey: newKey,
          graph: node.getGraph()
        });
      }
      return writes;
    }

    static changeNodeId(node, newId, writes = []) {
      return writes.push({
        action: "change-node-id",
        id: newId,
        oldId: node.id(),
        graph: node.getGraph()
      });
    }

    static reverseRelation(key, sourceNode, targetNode, originalRelationNode) {
      var graph, id, replaceId, result;
      id = Weaver.Node.generateId();
      graph = originalRelationNode.getGraph();
      replaceId = Weaver.Node.generateId();
      result = {
        action: "create-relation",
        id,
        graph,
        sourceId: sourceNode.id(),
        sourceGraph: sourceNode.getGraph(),
        key,
        targetId: targetNode.id(),
        targetGraph: targetNode.getGraph(),
        replacesId: originalRelationNode.id(),
        replacesGraph: originalRelationNode.getGraph(),
        replaceId,
        replaceGraph: graph
      };
      return result;
    }

  };

  module.exports = Functions;

}).call(this);
